import styled from 'styled-components';

import { withLayoutProps } from '@/utils/withLayoutProps';

export const StyledFlexRow = withLayoutProps(styled.div`
  display: flex;
  flex-direction: row;
`);

export const StyledFlexColumn = withLayoutProps(styled.div`
  display: flex;
  flex-direction: column;
`);
